import { render, staticRenderFns } from "./addPrizes.vue?vue&type=template&id=195a10b5&scoped=true"
import script from "./addPrizes.vue?vue&type=script&lang=js"
export * from "./addPrizes.vue?vue&type=script&lang=js"
import style0 from "./addPrizes.vue?vue&type=style&index=0&id=195a10b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a10b5",
  null
  
)

export default component.exports